import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Table from '../../../../components/table/Table'
import RadioButton from '../../../../components/form/RadioButton'
import { BizChannelTypeNames, BizChannelTypes } from '../../../Codes'
import { setBizChannelType } from '../channelAddSlice'
import { useConfirm } from '../../../dialog/Confirm'
import { isPresent } from '../../../../utils'
import fetchTalkChannels from '../thunk/fetchTalkChannels'

const BizChannelType = () => {
  const dispatch = useDispatch()
  const { bizChannelId, bizChannelType } = useSelector(
    state => state.channel.channelAdd
  )
  const [nextBizChannelType, setNextBizChannelType] = useState(bizChannelType)
  const [Confirm, showConfirm] = useConfirm()
  const disabled = isPresent(bizChannelId)
  const handleChange = type => {
    setNextBizChannelType(type)
    showConfirm()
  }
  const handleClose = ({ isConfirmed }) => {
    if (isConfirmed) {
      dispatch(setBizChannelType(nextBizChannelType))
      dispatch(fetchTalkChannels())
    }
  }
  return (
    <>
      <Table.Row className="tr_account">
        <th scope="row">
          <div className="inner_tbl">비즈채널 유형</div>
        </th>
        <td>
          <div className="inner_tbl">
            <div className="item_filter">
              <div className="filter_radio">
                <RadioButton
                  checkValue={bizChannelType}
                  value={BizChannelTypes.WEBSITE_BIZ_CHANNEL}
                  label={
                    BizChannelTypeNames[BizChannelTypes.WEBSITE_BIZ_CHANNEL]
                  }
                  onValueChange={handleChange}
                  disabled={disabled}
                />
                <RadioButton
                  checkValue={bizChannelType}
                  value={BizChannelTypes.TALK_CHANNEL}
                  label={BizChannelTypeNames[BizChannelTypes.TALK_CHANNEL]}
                  onValueChange={handleChange}
                  disabled={disabled}
                />
              </div>
            </div>
          </div>
        </td>
      </Table.Row>
      <Confirm title="비즈채널 유형 변경" onClose={handleClose}>
        유형 변경 시 기존 내용은 저장되지 않습니다.
      </Confirm>
    </>
  )
}
export default BizChannelType
